import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/layout/discover_dark.svg'
import _imports_1 from '@/assets/img/layout/discover_white.svg'
import _imports_2 from '@/assets/img/layout/diary_dark.svg'
import _imports_3 from '@/assets/img/layout/diary_white.svg'
import _imports_4 from '@/assets/img/layout/chat_dark.svg'
import _imports_5 from '@/assets/img/layout/chat_white.svg'
import _imports_6 from '@/assets/img/layout/notification_dark.svg'
import _imports_7 from '@/assets/img/layout/notification_white.svg'
import _imports_8 from '@/assets/img/layout/profile_dark.svg'
import _imports_9 from '@/assets/img/layout/profile_white.svg'


const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  key: 0,
  class: "navigationFooter"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "off"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "on"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "off"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "on"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "pallinoNotifiche"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "off"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "on"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "pallinoNotifiche"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  class: "off"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_7,
  class: "on"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "pallinoNotifiche"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_8,
  class: "off"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_9,
  class: "on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (!_ctx.$route.meta.hideFooter)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", {
            class: ["navItem", _ctx.activeTab == 'home' ? 'active' : '']
          }, [
            _createVNode(_component_router_link, {
              to: "/home",
              class: _ctx.activeTab == 'home' ? 'router-link-active' : '',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'home'))
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_discover",
                  text: "Discover",
                  class: "fs_11 spaceCadet"
                })
              ]),
              _: 1
            }, 8, ["class"])
          ], 2),
          _createVNode("div", {
            class: ["navItem", _ctx.activeTab == 'communities' ? 'active' : '']
          }, [
            _createVNode(_component_router_link, {
              to: _ctx.communitiesLink,
              class: _ctx.activeTab == 'communities' ? 'router-link-active' : '',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'communities'))
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_myDiary",
                  text: "My Diary",
                  class: "fs_11 spaceCadet"
                })
              ]),
              _: 1
            }, 8, ["to", "class"])
          ], 2),
          _createVNode("div", {
            class: ["navItem position-relative", _ctx.activeTab == 'chats' ? 'active' : '']
          }, [
            _createVNode(_component_router_link, {
              to: "/chats",
              class: _ctx.activeTab == 'chats' ? 'router-link-active' : '',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'chats'))
            }, {
              default: _withCtx(() => [
                (_ctx.hasNewChatMessages)
                  ? (_openBlock(), _createBlock("div", _hoisted_7))
                  : _createCommentVNode("", true),
                _hoisted_8,
                _hoisted_9,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_chat",
                  text: "Chat",
                  class: "fs_11 spaceCadet"
                })
              ]),
              _: 1
            }, 8, ["class"])
          ], 2),
          _createVNode("div", {
            class: ["navItem position-relative", _ctx.activeTab == 'notification' ? 'active' : '']
          }, [
            _createVNode(_component_router_link, {
              to: "/notification",
              class: _ctx.activeTab == 'notification' ? 'router-link-active' : '',
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'notification'))
            }, {
              default: _withCtx(() => [
                (_ctx.$store.state.newNotificationCount)
                  ? (_openBlock(), _createBlock("div", _hoisted_10))
                  : _createCommentVNode("", true),
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_notification",
                  text: "Notification",
                  class: "fs_11 spaceCadet"
                })
              ]),
              _: 1
            }, 8, ["class"])
          ], 2),
          (_ctx.$store.state.user)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["navItem position-relative", _ctx.activeTab == 'profile' ? 'active' : '']
              }, [
                _createVNode(_component_router_link, {
                  to: '/profile/' + _ctx.$store.state.user.identifier,
                  class: _ctx.activeTab == 'profile' ? 'router-link-active' : '',
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'profile'))
                }, {
                  default: _withCtx(() => [
                    (_ctx.hasNewInvitation || !_ctx.$store.state.user.profileCompleted)
                      ? (_openBlock(), _createBlock("div", _hoisted_13))
                      : _createCommentVNode("", true),
                    _hoisted_14,
                    _hoisted_15,
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_profile",
                      text: "Profile",
                      class: "fs_11 spaceCadet"
                    })
                  ]),
                  _: 1
                }, 8, ["to", "class"])
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}